<template>
    <div
        class="flex items-center px-2 py-1 font-xl ml-2 text-sm md:text-md"
        :title="$t('Balance')">
        <font-awesome-icon class="mr-2" icon="wallet"/>
        <span><span class="hidden md:inline">{{ $t('Balance') }}: </span>{{ newBalance | currency }}</span>
    </div>
</template>

<script>
export default {
    name: 'Balance',
    props: ['balance'],
    data() {
        return {
            newBalance: 0
        }
    },
    created() {
        this.newBalance = this.balance ?? 0;
        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('BalanceChanged', (e) => {
                this.newBalance = e.balance;
            })
            .listen('PlayerDeactivated', (e) => {
                this.$inertia.visit(this.route('terminal.register'));
            });
    }
}
</script>

<style lang="sass" scoped>

</style>
